/**
 * Check if a prop is a valid React element (component, context, etc)
 * To be used in PropType checking
 */

import { isValidElementType } from 'react-is';

const PropIsValidReactElement = (props, propName, componentName) => {
  if (props[propName] && !isValidElementType(props[propName])) {
    return new Error(
      `Invalid prop '${propName}' supplied to '${componentName}': the prop is not a valid React component`
    );
  }
};

export default PropIsValidReactElement;
